import React from 'react';
import * as yup from 'yup';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { HookFormTextInput } from '@components/ReactHookFormFields/HookFormTextInput';
import { useCustomTranslations } from '@hooks/useCustomTranslations';
import { DisturbanceLocation } from '@models/api/Incident';
import { formatDateToPlainDateInTimeZone } from '@utils/date.utils';

import { IncidentFormWrapper } from '../IncidentFormWrapper';

import {
  DisturbanceReportFormBase,
  useDisturbanceReport,
} from './Disturbance.utils';
import { DisturbanceCommonForm } from './DisturbanceCommonForm';

interface CommonSpacesForm extends DisturbanceReportFormBase {
  disturbanceArea?: string;
}

export const DisturbanceCommonSpacesForm = (props: ParsedEntry<IWidget>) => {
  const { t } = useCustomTranslations(props.customTranslations);

  const { create, defaultInitialValues, defaultValidationSchema } =
    useDisturbanceReport();

  return (
    <IncidentFormWrapper<CommonSpacesForm & DisturbanceReportFormBase>
      incidentKind="DisturbanceCommonSpaces"
      defaultValues={{ ...defaultInitialValues, disturbanceArea: '' }}
      validationSchema={defaultValidationSchema.concat(
        yup.object().shape({
          disturbanceArea: yup.string(),
        })
      )}
      onSubmit={({ disturbanceTimes, ...values }) =>
        create({
          ...values,
          disturbanceLocation: DisturbanceLocation.COMMON,
          dateTime: disturbanceTimes.map((date) =>
            formatDateToPlainDateInTimeZone(date)
          ),
        })
      }
    >
      <HookFormTextInput
        name="disturbanceArea"
        label={{ value: t('disturbanceAreaLabel'), type: 'static' }}
        placeholder={t('disturbanceAreaPlaceholder')}
        maxLength={150}
      />

      <DisturbanceCommonForm {...props} />
    </IncidentFormWrapper>
  );
};
